// 手机号正则 - 中国 11位数字
export const IS_PHONE_CN = /^[0-9]{11}$/;
// 手机号正则 - 意大利 9-10位数字
export const IS_PHONE_IT = /^[0-9]{9,10}$/;
// 手机号正则 - 西班牙 9位数字
export const IS_PHONE_ES = /^[0-9]{9}$/;
// 手机号正则 - 卢森堡 8-9位数字
export const IS_PHONE_LU = /^[0-9]{8,9}$/;
// 手机号正则 - 法国 9位数字
export const IS_PHONE_FR = /^[0-9]{9}$/;
// 手机号正则 - 阿尔巴尼亚 9位数字
export const IS_PHONE_AL = /^[0-9]{9}$/;
// 手机号正则 - 德国 10-11位数字
export const IS_PHONE_DE = /^[0-9]{10,11}$/;
// 手机号正则 - 斯洛文尼亚 8位数字
export const IS_PHONE_SI = /^[0-9]{8}$/;
// 手机号正则 - 葡萄牙 9位数字
export const IS_PHONE_PT = /^[0-9]{9}$/;
// 手机号正则 - 奥地利 10位数字
export const IS_PHONE_AT = /^[0-9]{10}$/;

export const onlyCountries = ['it', 'cn', 'es', 'lu', 'fr', 'al', 'de', 'si', 'pt', 'at'];
// 手机号正则
/**
 * 校验手机号码位数
 * @param code  
 * @returns
 */
const PHONE_PATTERNS = {
    '86': IS_PHONE_CN,
    '39': IS_PHONE_IT,
    '34': IS_PHONE_ES,
    '352': IS_PHONE_LU,
    '33': IS_PHONE_FR,
    '355': IS_PHONE_AL,
    '49': IS_PHONE_DE,
    '386': IS_PHONE_SI,
    '351': IS_PHONE_PT,
    '43': IS_PHONE_AT
} as const;

export const IS_PHONE = (code: string, phone: string) => {
    return PHONE_PATTERNS[code]?.test(phone) || false;
}

// 密码正则
export const IS_PASSWORD = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/;
// 验证码正则
export const IS_VCODE = /^\d{6}$/;
// 邮箱验证正则
// 不需要eslint校验
// eslint-disable-next-line no-useless-escape
export const IS_EMAIL = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
// 姓氏或名称正则
export const IS_CUSTOMER_NAME = /^[^\s].{0,30}$/;

export declare type PropType<T, P extends keyof T> = T[P];